export const sidebarData = [
  {
    link: 'https://tests.practicereasoningtests.com/shl',
    img: 'sidebar-test-shl.png',
    title: 'SHL Practice Test',
    color: '#5CBFE9',
  },
  {
    link: 'https://tests.practicereasoningtests.com/general-aptitude-test',
    img: 'sidebar-test-numerical.png',
    title: 'Practice Aptitude Test',
    color: '#257ABD',
  },
  {
    link: 'https://tests.practicereasoningtests.com/korn-ferry',
    img: 'sidebar-test-inductive.png',
    title: 'Korn Ferry Practice Test',
    color: '#37BA86',
  },
  {
    link: 'https://tests.practicereasoningtests.com/bksb',
    img: 'sidebar-test-abstact.png',
    title: 'BKSB Practice Test',
    color: '#BAA44E',
  },
  {
    link: 'https://tests.practicereasoningtests.com/watson-glaser-test',
    img: 'sidebar-test-cognitive.png',
    title: 'Watson Glaser Practice Test',
    color: '#FB7921',
  },
  {
    link: 'https://tests.practicereasoningtests.com/thomas-gia-test',
    img: 'sidebar-test-logical.png',
    title: 'Thomas Gia Practice Test',
    color: '#264E71',
  },
  {
    link: 'https://tests.practicereasoningtests.com/saville-executive',
    img: 'sidebar-test-caliper.png',
    title: 'Saville Executive Practice Test',
    color: '#5cbfea',
  },
  {
    link: 'https://tests.practicereasoningtests.com/iegat-test',
    img: 'sidebar-test-pi.png',
    title: 'ieGAT Practice Test',
    color: '#37BA86',
  },
  {
    link: 'https://tests.practicereasoningtests.com/hbri-test',
    img: 'sidebar-test-hogan.png',
    title: 'HBRI Practice Test',
    color: '#BAA44E',
  },
]

export default sidebarData
